import React, { useState } from 'react';
import '../App.css';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Do I need a gym or equipment?",
      answer: "No, you don't need a gym or special equipment. You can do most of the exercises at home with minimal gear.",
      
    },
    {
      question: "I am a beginner/in my 40s-50s — will this work for me?",
      answer: "Absolutely, every session has progression and regression so everyone can follow safely.",
      
    },
    {
      question: "I’ve got tight hips/shoulders or past injuries. Is it safe?",
      answer: "Yes, all exercises can be modified for injuries or tight muscles. Guidance is provided on how to adjust safely.",
     
    },
    {
      question: "How does the coaching work?",
      answer: "You will be trained inside the app — simple, clear, and follow-along.",
  
    }
  ];

  return (
    <div className="faq-container">
      <h2 className="faq-heading">FREQUENTLY ASKED QUESTIONS</h2>
      {faqs.map((faq, index) => (
        <div className="faq-item" key={index}>
          <div 
            className={`faq-question ${openIndex === index ? 'open' : ''}`}
            onClick={() => toggleAnswer(index)}
          >
            <span className="faq-plus">{openIndex === index ? '–' : '+'}</span>
            <p>{faq.question}</p>
          </div>
          {openIndex === index && (
            <div className="faq-answer">
              <p>{faq.answer}</p>
              <div className="faq-extra">
                <p>{faq.extra}</p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;
